<div class="modal fade" id="eventDetailsModal" tabindex="-1" aria-labelledby="eventDetailsModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header bg-primary text-white">
                <h5 class="modal-title" id="eventDetailsModal">{{eventDetails.Title}}</h5><button type="button"
                    class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body scheduler__modal-body">
                <p><strong>Description:</strong> {{ eventDetails.Description }}</p>
                <p><strong>Event Type:</strong> {{ eventDetails.EventType }}</p>
                <p><strong>Start Time:</strong> {{ eventDetails.StartDateTime }}</p>
                <p><strong>End Time:</strong> {{ eventDetails.EndDateTime }}</p>
                <p><strong>Is Flagged:</strong> {{ eventDetails.IsFlagged }}</p>
                <p><strong>Is Completed:</strong> {{ eventDetails.IsCompleted }}</p>

                <transflo-document-metadata [metadata]="documentMetadata" [documentName]="documentName"
                    [showPopup]="showPopup" [eventId]="eventId" (close)="onClosePopup()"
                    (submit)="onSubmitForm($event)">
                </transflo-document-metadata>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" (click)="nextEvent()"
                    *ngIf="!eventDetails.IsCompleted">Next</button>
            </div>
        </div>
    </div>
</div>
